// @flow
import React, { Component } from "react"

type Props = {
  onHide: (e: mixed) => void,
}

class BodyLayer extends Component<Props> {
  componentDidMount() {
    document.addEventListener("click", this.clickOutside, false)
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.clickOutside, false)
  }

  clickOutside = (e: MouseEvent) => {
    if (!e.defaultPrevented) {
      this.props.onHide(e.target)
    }
  }

  render() {
    return <div />
  }
}

export default BodyLayer
